import { PropsWithChildren } from "react";

interface HeadingProps extends PropsWithChildren {}
export const Heading = ({ children }: HeadingProps) => {
  return <h1 className="text-2xl">{children}</h1>;
};
